import $ from "jquery";

// @ts-ignore
window.Waves = Waves;
// @ts-ignore
window.jQuery = window.$ = $;